import { Button } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useCurrentPage } from '../../../hooks/useCurrentPage'

interface Props {
  onExport: () => Promise<void>
}

export const ExportButton = ({ onExport }: Props) => {
  const currentRoute = useCurrentPage()

  const handleExport = () => {
    onExport()

    track(trackingEvents.accounting.newFinancialWorkspace.export, {
      page: currentRoute,
    })
  }

  return (
    <Button type="secondary" iconName="download" onClick={handleExport}>
      {i18n.t('common.export')}
    </Button>
  )
}
